var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c("full-screen-toggle", {
        staticClass: "flex-grow flex flex-col",
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (fullScreenSlotProps) {
                return [
                  _c(
                    "grid",
                    {
                      key: _vm.documentGridKey,
                      ref: "documentGrid",
                      staticClass: "flex-grow",
                      attrs: {
                        "data-source": _vm.dataSource,
                        "include-excel-export": "",
                        "include-clear-all": "",
                        "include-full-screen": "",
                        "export-filename": _vm.exportFileName,
                      },
                      on: { "row-double-clicked": _vm.onRowDoubleClick },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "toolbar-actions",
                            fn: function (slotProps) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "w-54 pb-2 pt-2" },
                                  [
                                    _c(
                                      "btn",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.AddDocument()
                                          },
                                        },
                                      },
                                      [_vm._v("Upload New Document(s)")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("spacer"),
                                _vm._v(" "),
                                _c("div", { staticClass: "grow" }),
                                _vm._v(" "),
                                _c("action", {
                                  staticClass: "pr-2",
                                  attrs: {
                                    icon: "mdi mdi-filter-remove-outline",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return slotProps.onClearFilter()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("action", {
                                  staticClass: "ml pr-2",
                                  attrs: { icon: "mdi mdi-microsoft-excel" },
                                  on: {
                                    click: function ($event) {
                                      return slotProps.exportToExcel()
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("action", {
                                  staticClass: "ml pr-2",
                                  attrs: { icon: "mdi mdi-arrow-expand-all" },
                                  on: {
                                    click: function ($event) {
                                      return slotProps.onFullScreenToggle()
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          "header-name": "",
                          "min-width": 40,
                          width: 40,
                          "suppress-header-menu-button": true,
                          sortable: false,
                          pinned: "left",
                          "cell-renderer": "iconButtonRenderer",
                          "cell-renderer-params": {
                            onClick: _vm.onDownloadDocumentClick,
                            icon: "icon-download",
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          "header-name": "",
                          "min-width": 40,
                          width: 40,
                          "suppress-header-menu-button": true,
                          sortable: false,
                          pinned: "left",
                          "cell-renderer": "iconButtonRenderer",
                          "cell-renderer-params": {
                            onClick: _vm.onEditPackageDocumentClick,
                            icon: "icon-edit",
                            hidden: _vm.hideEditPackageDocument,
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          "header-name": "",
                          "min-width": 40,
                          width: 40,
                          "suppress-header-menu-button": true,
                          sortable: false,
                          pinned: "left",
                          "cell-renderer-selector": _vm.getDeleteRenderer,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          "header-name": "",
                          "min-width": 40,
                          width: 40,
                          "suppress-header-menu-button": true,
                          sortable: false,
                          pinned: "left",
                          "cell-renderer": "iconButtonRenderer",
                          "cell-renderer-params": {
                            onClick: _vm.onRestorePackageDocumentClick,
                            icon: "icon-unarchive",
                            hidden: _vm.hideIsArchivedButton,
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "documentName",
                          "header-name": "Document Name",
                          "min-width": 200,
                          filter: "agTextColumnFilter",
                          width: 250,
                          "floating-filter": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "documentTypeName",
                          "header-name": "Document Type",
                          "min-width": 80,
                          filter: "agTextColumnFilter",
                          width: 200,
                          "floating-filter": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "createdDate",
                          "header-name": "Uploaded Date",
                          "min-width": 150,
                          "suppress-header-menu-button": true,
                          type: "date",
                          "date-format": "MM/dd/yyyy hh:mm:ss a",
                          sort: "desc",
                          "floating-filter": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "createdBy",
                          "header-name": "Updated By",
                          "min-width": 150,
                          filter: "agTextColumnFilter",
                          "floating-filter": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "documentTag",
                          "header-name": "Document Tag",
                          "min-width": 200,
                          filter: "agTextColumnFilter",
                          "floating-filter": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("grid-column", {
                        attrs: {
                          field: "documentNumber",
                          "header-name": "Document ID",
                          filter: "agTextColumnFilter",
                          type: "number",
                          "min-width": 120,
                          "floating-filter": true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          false,
          4233023576
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }